import {Pipe, PipeTransform} from "@angular/core"
import {stringToDate} from "@common/helpers/utils/dates"
import {formatDistanceToNow} from "date-fns/formatDistanceToNow"

@Pipe({
    name: "cmTimeAgo",
})
export class TimeAgoPipe implements PipeTransform {
    // `concise` drops date-fns' leading "about " qualifier (e.g. "about 1 month ago"
    // -> "1 month ago") for space-constrained labels such as compact badges.
    transform(dateOrString: string | Date | null | undefined, concise = false): string | undefined {
        const date = stringToDate(dateOrString)
        if (date) {
            const distance = formatDistanceToNow(date, {addSuffix: true})
            return concise ? distance.replace(/^about /, "") : distance
        }
        return undefined
    }
}
